import { seqRange } from "./batch.js";
import { pathAndSearch } from "./sanitize.js";

/**
 * Bug-report fields that link the report to the telemetry session: the tab and
 * seq window of the attached ring-buffer entries, the client build, and the page
 * URL without its fragment (a fragment can carry a capability secret). With the P2
 * visits group on, also the visit and the tab's `tab.start` snapshot (the state the
 * tab started in); both are omitted otherwise.
 */
export function bugReportSessionFields({
  logEvents,
  tabId,
  buildSha,
  location,
  visitId = null,
  tabStart = null,
}) {
  const { from, to } = seqRange(logEvents);
  return {
    client_build_sha: buildSha,
    tab_id: tabId,
    seq_from: from,
    seq_to: to,
    url_at_report: pathAndSearch(location),
    ...(visitId ? { visit_id: visitId } : {}),
    ...(tabStart ? { tab_start: tabStart } : {}),
  };
}
